import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms'
import {RouterLink} from "@angular/router";
import {NgIf} from '@angular/common';
import {AutosizeModule} from 'ngx-autosize';

@Component({
  selector: 'app-read-only-static[value]',
  templateUrl: './read-only-static.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useClass: ReadOnlyStaticComponent,
      multi: true
    }
  ],
  imports: [FormsModule, RouterLink, NgIf, AutosizeModule],
  standalone: true
})
export class ReadOnlyStaticComponent {

  @Input() public label!: string
  @Input() public name!: string
  @Input() public customClasses = '';
  @Input() public errorMessages!: Record<string, string>
  @Input() public small = false
  @Input() public tabindex?: number
  @Input() public placeholder = ''
  @Input() public type: 'text' | 'textarea' = 'text';
  @Input() public link?: string;
  @Input() public valueAlign: 'start' | 'end' = 'start';

  @Input() public value?: string | number | null;
  @Input() public valueIsHTML?: boolean;

  @Input() public minRows = 3

  constructor() {}
}
